import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import RCG from 'react-captcha-generator';
import '../css/Register.css';
import Vas from '../Vas';

import { ExtendedButton,Checkbox,TextField,Icon,SelectField,DateField,AutocompleteField,Loading } from "component-lib";
import { DateTimeHelper } from 'utils-lib';

import { SchoolsModel, StreetsModel, RequestAjaxClass, EmailModel, AccountsModel } from 'models-lib';

var moment = require('moment');
moment().format();

class Register  extends Component {

//#region Komponente    
    constructor(props)
    {
        super(props);
        this.state = {};
        this.setCaptcha();
        this.state.name= '';
        this.state.firstName = '';
        this.state.gender = 0;
        this.state.dateOfBirth = null;
        this.state.street = '';
        this.state.houseNumber = '';
        this.state.zip = null;
        this.state.email = '';

        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null); 
        this.Request2 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null); 
        this.Request3 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null); 

        this.SchoolsModel = new SchoolsModel([this],null,this.Request);
        this.StreetsModel = new StreetsModel([this],null,this.Request2);
        this.EmailModel = new EmailModel([this],null,this.Request3);
        this.AccountsModel = new AccountsModel([this],null,this.Request);
        
    }
    
    componentDidMount()
    {
      this.Request.setAuth(false);
      this.Request.setApiKey(Vas.ApiKey);
      this.Request.setApiUrl(Vas.ApiUrl);
      this.Request.setErrorHandler(()=>{
        
      });

      this.Request2.setAuth(false);
      this.Request2.setApiKey(Vas.ApiKey);
      this.Request2.setApiUrl(Vas.ApiUrl);
      this.Request2.setErrorHandler(()=>{
        
      });

      this.Request3.setAuth(false);
      this.Request3.setApiKey(Vas.ApiKey);
      this.Request3.setApiUrl(Vas.ApiUrl);
      this.Request3.setErrorHandler(()=>{
        
      });
           
        this.setState({ requiredFields:[this.refs.name, this.refs.firstname, this.refs.dateOfBirth, this.refs.street, this.refs.houseNumber, this.refs.zip, this.refs.place, 
                    this.refs.schoolPlace, this.refs.email, this.refs.captcha],
                    requiredCeckBox:[this.refs.AGB,this.refs.Daten],
                    requiredSelectField:[this.refs.Schools], },()=>{
                        for (let i=0; i<this.state.requiredFields.length; i++){
                            if (this.state.requiredFields[i].props.IsRequired){
                                this.state.requiredFields[i].setState({ Label:this.state.requiredFields[i].props.Label+"*" });
                            }
                        }
                        for (let i=0; i<this.state.requiredSelectField.length; i++){
                            if (this.state.requiredSelectField[i].props.IsRequired){
                                this.state.requiredSelectField[i].setState({ Label:this.state.requiredSelectField[i].props.Label+"*" });
                            }
                        }
                    this.checkFields();
                    });
    }
    
    componentDidUpdate(){
        this.checkFields();
    }
    /**
     * updates the state object
     * @constructor
     */
    Update(observer)
    {
      let me = this;
      this.setState({},()=>{
        if(observer === "Schools"){
          let possibleSchools = [];
          for (let i = 0; i < me.SchoolsModel.Schools.length; i++) {
              possibleSchools.push({ Key: me.SchoolsModel.Schools[i].Id, Display: me.SchoolsModel.Schools[i].Name1 });
          }
          me.setState({ schools: possibleSchools });
          me.refs.Schools.setState({ Data: possibleSchools, Icon:'' });
        }
        else if(observer === "Streets"){
          let streets = [];
          if (me.StreetsModel.Streets)
          {
              streets = me.StreetsModel.Streets;
          }
          me.refs.street.setState({ Data: streets, Icon : '' });
          me.setState({ streets: streets });
        }
        else if(observer === "CheckMail"){
          if (me.EmailModel.ValidSyntax && !me.EmailModel.AccountExists )
          {
              me.setState({ Email: $("#email").val(), EmailValid: true });
              me.refs.IconEmail.setState({ Name:"Done", Color:"green",Tooltip:"" });
          }
          else
          {
              me.setState({ Email: $("#email").val(), EmailValid: false });
              me.refs.IconEmail.setState({ Name:"Warning", Color:"red",Tooltip:Vas.Resources.Tooltips["EmailTaken"] });
          }
        }
        else if( observer === "AccountCreate"){
          ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
          Vas.GetView('Login');
        }
      });
    }

//#endregion

//#region Captcha
    setCaptcha(){
        this.check = this.check.bind(this);
        this.result = this.result.bind(this);
    }

    result(text) {
        this.setState({ captcha: text });
    }

    check() {
        if (this.state.captcha !== document.getElementById("captcha").value){
            this.reset();
        } else {
            this.setState({ captcha:document.getElementById("captcha").value });
        }        
    }

    reset(){
        this.refs.RCG.setData();
        document.getElementById("captcha").value="";
        this.refs.Register.setState({ usable:false }); 
    }
//#endregion

//#region get Data
    getSchools ()
    {
        let me = this;

        me.refs.Schools.setState({ Icon:"Loop" });
        if (me.state.schoolPlace !== "")
        {
          this.SchoolsModel.GetSchoolsByCity(me.state.schoolPlace);
        }
    }

    getStreets() //holt alle Straßen für eine eingegebene PLZ und Ort
    {
        let me = this;
        me.refs.street.setState({ Icon:"Loop" });
        if (me.state.Place && me.state.Zip){ //PLZ und Ort müssen eingegeben sein
          this.StreetsModel.GetStreets(encodeURI(me.state.Place),me.state.Zip);
        }
    }

//#endregion

//#region check Fields
    checkEmail()
    {
      this.EmailModel.CheckMail($("#email").val());
    }

    checkFields(){
        let count;
        let filled=0;
        
        if (this.state.requiredFields && this.state.requiredCeckBox && this.state.requiredSelectField ){
            count=this.state.requiredFields.length+this.state.requiredCeckBox.length+this.state.requiredSelectField.length;

            for (let i=0;i<this.state.requiredFields.length;i++){
                if (this.state.requiredFields[i]){
                    if (document.getElementById(this.state.requiredFields[i].props.Id).value.length>0){
                        if (this.state.requiredFields[i].props.Id==="email"){
                            if (this.state.EmailValid===true){
                                filled++;    
                            }
                        } else {
                            filled++;
                        }
                    }
                }
            }

            for (let j=0; j<this.state.requiredCeckBox.length;j++){
                if (this.state.requiredCeckBox[j]){
                    if (document.getElementById(this.state.requiredCeckBox[j].props.Id).checked === true){
                        filled++;
                    }
                }
            }

            for (let k=0; k<this.state.requiredSelectField.length;k++){
                if (this.state.requiredSelectField[k]){
                
                    if (document.getElementById(this.state.requiredSelectField[k].props.Id).selectedIndex >0){
                        filled++;
                    }
                }
            }
            
            if (filled < count){
                this.refs.Register.setState({ usable:false });
            } else {
                this.refs.Register.setState({ usable:true });
            }
        } 
    }

    AGBClick(){
        document.getElementById("ceckboxAGB").checked=true;
    }

    DatenClick(){
        document.getElementById("checkboxDaten").checked=true;
    }

//#endregion
    
    Register(){
        ReactDOM.render(<Loading modal={true} />,document.getElementById('popupContainer'));
        let cur = DateTimeHelper.StringToDate(this.state.DateOfBirth,false,localStorage.getItem('vas_language'));
           
        this.AccountsModel.Customer = {
            City: this.state.Place,
            Class: "",
            Country: "",
            CustomerCategory: "",
            CustomerNumber: "",
            DateOfBirth: moment([cur.year(),cur.month(),cur.date()]).format('YYYY-MM-DD T 00:00:00'),
            Email: this.state.Email,
            Fax: "",
            Gender: this.state.Gender,
            GradeLevel: 0,
            HouseNumber: this.state.HouseNumber,
            Id: "",
            MarketingEmail: false,
            MarketingPhone: false,
            MarketingPost: false,
            Name1: this.state.Name,
            Name2: this.state.FirstName,
            Name3: this.state.AddressAddition,
            Phone: "",
            Phone2: "",
            PostCode: this.state.Zip,
            Salutation: "",
            Street: this.state.Street,
            Title: "",
            HouseNumberAddition:this.state.HouseNumberAddition
        };
        
        this.Request.setErrorHandler(()=>{
          ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
        });
        this.AccountsModel.AccountCreate(this.state.SchoolId);
    }

    render()
    {
        let maxValue = moment(); //maxValue gür Geburtsdatums DatePicker, es darf kein Wert nach heute eingebenen werden
        
        let min = moment();
        let minValue = moment([min.year() - 18, min.month(), min.date()+1]); //minValue für Geburtsdatums Datepicker der Geschwister und der bestellenden Person, sie dürfen nicht älter als 18 Jahre sein

        return (
          <div className={"RegisterContainer"}>
            <div className={"form"}>
              <div>
                <h2>{Vas.Resources.Titles["Register"]}</h2>
                    
                <table className={"StepperTable"} >
                  <tbody>
                    <tr>
                      <td>
                        <TextField
                          AppURL={Vas.ApplicationUrl}
                          me={this}
                          Modus={"Name"}
                          Id={"name"}
                          ref={"name"}
                          IsRequired={true}
                          Editable={true}
                          name="name"
                          Label={Vas.Resources.Labels["Name"]}
                          Tooltip={Vas.Resources.Tooltips["Name"]}
                          OnChange={()=>{ this.setState({ Name:  $("#name").val() });}}
                          defaultValue={this.state.name} />
                      </td>
                      <td>
                        <TextField
                          AppURL={Vas.ApplicationUrl}
                          me={this}
                          Modus={"Name"}
                          Id={"firstname"}
                          ref={"firstname"}
                          IsRequired={true}
                          Editable={true}
                          name="firstName"
                          Label={Vas.Resources.Labels["FirstName"]}
                          Tooltip={Vas.Resources.Tooltips["Firstname"]}
                          OnChange={()=>{ this.setState( { FirstName:  $("#firstname").val() });}}
                          defaultValue={this.state.firstName} />
                      </td>
                    </tr>
                    <tr>
                      <td><SelectField
                        AppURL={Vas.ApplicationUrl}
                        SelectFieldChooseText={Vas.Resources.Labels["NotSpecified"]}
                        me={this}
                        Id={"Gender"}
                        ref={"gender"}
                        IsRequired={false}
                        Float={'left'}
                        Label={Vas.Resources.Labels["Gender"]}
                        Data={[{ Key: 'Männlich', Display: Vas.Resources.Labels["Male"] },{ Key: 'Weiblich', Display: Vas.Resources.Labels["Female"] }, { Key: 'Divers', Display: Vas.Resources.Labels["Divers"] }]}
                        OnBlur={()=>{ this.setState({ Gender: $("#Gender").val() });}}
                        Tooltip={Vas.Resources.Tooltips["Gender"]}/></td>
                      <td><DateField
                        AppURL={Vas.ApplicationUrl}
                        ChooseDataText={Vas.Resources.Labels["ChooseDate"]}
                        TooltipMonth={Vas.Resources.Tooltips["Month"]}
                        TooltipYear={Vas.Resources.Tooltips["Year"]}
                        CalenderText={[Vas.Resources.Calendar["January"] ,Vas.Resources.Calendar["February"] ,Vas.Resources.Calendar["March"] ,Vas.Resources.Calendar["April"] ,Vas.Resources.Calendar["May"] ,
                                        Vas.Resources.Calendar["June"] ,Vas.Resources.Calendar["July"] ,Vas.Resources.Calendar["August"] ,Vas.Resources.Calendar["September"] ,Vas.Resources.Calendar["October"] ,
                                        Vas.Resources.Calendar["November"] ,Vas.Resources.Calendar["December"] ]} 
                        CalenderWeekDayText={[ Vas.Resources.Calendar["CW"],Vas.Resources.Calendar["Monday"] ,Vas.Resources.Calendar["Tuesday"],Vas.Resources.Calendar["Wednesday"],
                                        Vas.Resources.Calendar["Thursday"],Vas.Resources.Calendar["Friday"],Vas.Resources.Calendar["Saturday"],Vas.Resources.Calendar["Sunday"]]}
                        Language={localStorage.getItem("vas_language")}
                        me={this}
                        Editable={true}
                        ref={"dateOfBirth"}
                        MaxValue={maxValue}
                        MinValue={minValue}
                        IsRequired={true}
                        Id={"DateOfBirth"}
                        Tooltip={Vas.Resources.Tooltips["DateOfBirth"]}
                        Label={Vas.Resources.Labels["DateOfBirth"]} 
                        OnBlur={()=>{this.setState( { DateOfBirth:  $("#DateOfBirth").val() });}}
                        defaultValue={this.state.dateOfBirth}
                        DateFalseFormatText={Vas.Resources.Labels["DateFalseFormat"]}
                        FalseDateTitle={Vas.Resources.Titles["Note"]}
                        FalseDateText={Vas.Resources.Labels["DateNotValid"]}
                        FalseMaxDateText={Vas.Resources.Labels["PupilDateOfBirthInvalid"]}
                        FalseMinDateText={Vas.Resources.Labels["PupilDateOfBirthInvalid"]} /></td>
                    </tr>
                    <tr>
                      <td colSpan="2"><TextField
                        AppURL={Vas.ApplicationUrl}
                        me={this}
                        Width={350}
                        Id="addressAddition"
                        Editable={true}
                        IsRequired={false}
                        Tooltip={Vas.Resources.Tooltips["AddressAddition"]}
                        Label={Vas.Resources.Labels["AddressAddition"]}
                        OnChange={()=>{ this.setState({ AddressAddition: $("#addressAddition").val() }); }} /></td>
                    </tr>
                    <tr>
                      <td><TextField
                        AppURL={Vas.ApplicationUrl}
                        me={this}
                        Editable={true}
                        IsRequired={true}
                        ref={"zip"}
                        Id={"zip"}
                        name="zip"
                        Tooltip={Vas.Resources.Tooltips["Zip"]}
                        Label={Vas.Resources.Labels["Zip"]}
                        OnChange={()=>{ this.setState( { Zip: $("#zip").val() });}}
                        defaultValue={this.state.zip} /></td>
                      <td><TextField
                        AppURL={Vas.ApplicationUrl}
                        me={this}
                        Editable={true}
                        IsRequired={true}
                        ref={"place"}
                        Id={"place"}
                        name="place"
                        Tooltip={Vas.Resources.Tooltips["Place"]}
                        Label={Vas.Resources.Labels["Place"]}
                        OnChange={()=>{ this.setState( { Place: $("#place").val() });}}
                        defaultValue={this.state.place}
                        OnBlur={()=>{this.getStreets();}} /> </td>
                    </tr>
                    <tr>
                      <td colSpan="2"><SelectField
                        AppURL={Vas.ApplicationUrl}
                        TitleMessageFalseStreet={Vas.Resources.Labels["Error"]}
                        MessageFalseStreet={Vas.Resources.Labels["FalseStreet"]/Vas.Resources.Labels["FalseProduct"]}
                        me={this}
                        Width={350}
                        ref={"street"}
                        Id={"street"}
                        Float={'left'}
                        Modus={"Street"}
                        IsRequired={true}
                        editable={true}
                        Label={Vas.Resources.Labels["Street"]}
                        Data={this.state.streets}
                        OnBlur={()=>{ this.setState({ Street: $("#street").val() }); }}
                        Tooltip={Vas.Resources.Tooltips["Street"]}
                        TimeOutTime={Vas.TimeOutTime} />
                      </td>
                                
                    </tr>
                    <tr>
                      <td><TextField
                        AppURL={Vas.ApplicationUrl}
                        me={this}
                        Editable={true}
                        IsRequired={true}
                        ref={"houseNumber"}
                        Id={"houseNumber"}
                        name="houseNumber"
                        Tooltip={Vas.Resources.Tooltips["Housenumber"]}
                        Label={Vas.Resources.Labels["HouseNumber"]}
                        OnChange={()=>{ this.setState( { HouseNumber: $("#houseNumber").val() });}}
                        defaultValue={this.state.houseNumber} /></td>
                      <td ><TextField
                        AppURL={Vas.ApplicationUrl}
                        me={this}
                        Id="houseNumberAddition"
                        Editable={true}
                        IsRequired={false}
                        Tooltip={Vas.Resources.Tooltips["HouseNumberAddition"]}
                        Label={Vas.Resources.Labels["HouseNumberAddition"]}
                        OnChange={()=>{ this.setState({ HouseNumberAddition: $("#houseNumberAddition").val() }); }} /></td>
                    </tr>
                    <tr>
                      <td colSpan="2"><TextField
                        AppURL={Vas.ApplicationUrl}
                        me={this}
                        Width={355}
                        Editable={true}
                        ref={"schoolPlace"}
                        IsRequired={true}
                        Id={"SchoolPlace"}
                        Tooltip={Vas.Resources.Tooltips["SchoolPlace"]}
                        OnBlur={()=>{ this.setState({ schoolPlace: $("#SchoolPlace").val() },()=>{ this.getSchools();});   }}
                        Label={Vas.Resources.Labels["SchoolPlace"]} /></td>
                    </tr>
                    <tr>
                      <td colSpan="2"><SelectField
                        AppURL={Vas.ApplicationUrl}
                        SelectFieldChooseText={Vas.Resources.Labels["PleaseChoose"]}
                        me={this}
                        Width={355}
                        ref={"Schools"}
                        Id={"Schools"}
                        Editable={true}
                        IsRequired={true}
                        Tooltip={Vas.Resources.Tooltips["School"]}
                        Label={Vas.Resources.Labels["School"]}
                        OnChange={()=>{ this.setState({ SchoolId: $("#Schools").val() }); }} /></td>
                    </tr>
                    <tr>
                      <td colSpan="2"><TextField
                        AppURL={Vas.ApplicationUrl}
                        me={this}
                        Width={325}
                        Id="email"
                        ref={"email"}
                        OnBlur={()=>{ this.checkEmail();}}
                        Editable={true}
                        IsRequired={true}
                        Tooltip={Vas.Resources.Tooltips["Email"]}
                        Label={Vas.Resources.Labels["Email"]}
                        OnChange={()=>{ this.setState({ Email: $("#email").val() }); }} /><Icon
                          ref={"IconEmail"}
                          Name={"Warning"}
                          Size={24}
                          Color={"red"}
                          Align={"left"}
                          Tooltip={Vas.Resources.Tooltips["EmailTaken"]} /></td>
                    </tr>
                    <tr>
                      <td><TextField
                        AppURL={Vas.ApplicationUrl}
                        me={this}
                        Id="phone"
                        Editable={true}
                        IsRequired={false}
                        Tooltip={Vas.Resources.Tooltips["Phone"]}
                        Label={Vas.Resources.Labels["Phone"]}
                        OnChange={()=>{ this.setState({ Phone: $("#phone").val() }); }} /></td>
                    </tr>
                    <tr>
                      <td><RCG
                        result={this.result}
                        ref={"RCG"} /></td>
                      <td><Icon
                        Name={"Loop"}
                        Size={24}
                        Color={"black"}
                        Align={"left"}
                        OnClick={()=>{this.reset();}} /></td>
                    </tr>
                    <tr>
                      <td><TextField
                        AppURL={Vas.ApplicationUrl}
                        Id="captcha"
                        ref={"captcha"}
                        Width={170}
                        Editable={true}
                        Label={Vas.Resources.Labels["CheckWord"]+"*"}
                        OnBlur={(e)=>{this.check();}}
                        Tooltip={Vas.Resources.Tooltips["RCG"]} /><br /></td>
                    </tr> 
                            
                    <tr >
                      <td colSpan={2}><Checkbox
                        ref={"AGB"}
                        Id={"ceckboxAGB"}
                        onClick={()=>{this.setState({ AGB:$("#ceckboxAGB").val() });}} /><label htmlFor="cbox" >{Vas.Resources.Labels["Iamwith"]} <a
                          href={Vas.ApplicationUrl+"/Test1.pdf"}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={()=>{this.AGBClick();}}>{Vas.Resources.Labels["AGB"]}</a>* {Vas.Resources.Labels["Acccept"]}</label></td>
                    </tr>
                    <tr >
                      <td colSpan={2}><Checkbox
                        ref={"Daten"}
                        Id={"checkboxDaten"}
                        onClick={()=>{this.setState({ Daten:$("#checkboxDaten").val() });}} /><label htmlFor="cbox" >{Vas.Resources.Labels["Iamwith"]} <a
                          href={Vas.ApplicationUrl+"/Test2.pdf"}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={()=>{this.DatenClick();}}>{Vas.Resources.Labels["PrivacyPolicy"]}</a>* {Vas.Resources.Labels["Acccept"]} </label><br /></td>
                    </tr>
                    <tr>
                      <td><br />{Vas.Resources.Labels["RequiredField"]}<br /></td>
                    </tr>
                    <tr>
                      <td><ExtendedButton
                        ref={"Register"}
                        Usable={false}
                        Text={Vas.Resources.Labels["Create"]}
                        OnClick={()=>{ this.Register();}}
                        style={{ margin: 25 }} /></td>
                      <td><ExtendedButton
                        Usable={true}
                        Text={Vas.Resources.Labels["Cancel"]}
                        OnClick={()=>{Vas.GetView('Order');}}
                        style={{ margin: 25 }} /></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        );
    }
}
export default Register;
